import React, { Component } from 'react';
import { connect } from "react-redux";
import { Trans } from 'react-i18next';
class CovidOverlay extends Component {
    constructor(props) {    
        super(props);

        this.state = {
        };

        //
    }

    componentDidMount() {
    }
    render(props) {
        return (
            <div className = "reveal" id = "feedback-overlay" style={{display: "block",top:"0"}}> 
                <div className = "card">
                    <div className = "">
                        <button className="close-button" data-close aria-label='Close modal' type='button' onClick={this.props.closeModal}>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div className = "card-section">
                        <div className="covid-header"><Trans>We are providing the following process to protect you in this environment</Trans>:</div>
                        <div className="covid-card-text">
                            <Trans>1. Digital Booking</Trans>: <Trans>Digital VMS continues to facilitate online bookings at your convenience.</Trans><br/>
                            <Trans>2. Digital Documentation</Trans>: <Trans>All documentation and signatures are completed electronically.</Trans><br/>
                            <Trans>3. Vehicle Sanitization</Trans>: <Trans>Your vehicle will be sanitized with government-certified disinfectants while our Team is wearing appropriate Personal Protective Equipment.  A sanitization occurs immediately prior to your use.</Trans><br/>
                            <Trans>4. Contactless Handoff</Trans>: <Trans>The keys for your vehicle can be obtained using our remote keybox system, allowing you to pickup and dropoff the vehicle without risk of face-to-face contact.</Trans><br/><br/>
                            
                            <Trans>If you are exhibiting any symptoms of a cold or flu, before, during or after your vehicle use, please identify this to </Trans><a href="mailto:ewelina.flair@integratedauto.com">ewelina.flair@integratedauto.com</a>.  <Trans>Your information will be treated as confidential.</Trans><br/><br/>
                            
                            <Trans>For any questions regarding our Covid-19 processes, please contact</Trans> <a href="mailto:ewelina.flair@integratedauto.com">ewelina.flair@integratedauto.com</a>.
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(CovidOverlay)